import React from 'react';
import axios from 'axios';
import { Form, Input, InputNumber, DatePicker, Carousel, Checkbox, Button } from 'antd';

import moment from 'components/momentWithZone';
import withSpin from 'components/Portal/FieldAdmin/withSpin';

const apiPath = 'http://stagingadmin.semesteratsea.org/api';
const { TextArea } = Input;

const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 6 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 14 },
    },
    marginBottom: '8pt'
  };

const buttonStyle = {
    textAlign: 'right'
};
const contentStyle = {
    height: '160px',
    color: '#fff',
    lineHeight: '160px',
    textAlign: 'center',
    background: '#364d79'
};

const readonlyStyle = {
    fontWeight: '500',
    color: '#f24f52',
    backgroundColor: '#ffc1c2',
    cursor: 'not-allowed'
}

class DeleteProgram extends React.Component {
	state = {
        searchTerms: '',
        fieldProgramResult: {}
    }

    populateSearchTerm = (enteredCode) => {
        this.setState({searchTerms: enteredCode});
    }
    fetchFieldProgram = () => {
        if(this.state.searchTerms == '') {
            this.props.form.setFields({EnterCode: {errors:[new Error('Please enter a field program code.')]}});
            return;
        }

        console.log("searchTerms: " + this.state.searchTerms);
        // axios.get(apiPath + '/getExcursionByCode?code='+this.state.searchTerms, { withCredentials: true }).then(result => {
        //     this.setState({fieldProgram: result.data});
		// });
        this.setState({
			fieldProgramResult: {'Code': 'TST 100-105', 'CruiseNumber': 'SP20', 'DepartmentCode': '20200', 'Type': 'A', 'Port': 'SEY', 'Title': 'Test Title', 
							'Summary': 'This is a field program summary lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras at facilisis diam. Maecenas ornare scelerisque felis, id hendrerit nunc dictum eu.', 
							'Description': 'This is a realllllllyyyyy looooooooonnnnnnggggggg field program description Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras at facilisis diam. Maecenas ornare scelerisque felis, id hendrerit nunc dictum eu. Morbi orci velit, consectetur vel elit id, tempor luctus justo. Quisque id dolor mollis, bibendum eros non, consectetur quam. Maecenas justo sem, elementum sit amet velit sed, condimentum dignissim ipsum. Curabitur feugiat efficitur sem efficitur feugiat. Pellentesque non arcu at felis vestibulum malesuada quis sit amet arcu.',
							'Itinerary':'This is the field programs itinerary morbi orci velit, consectetur vel elit id, tempor luctus justo. Quisque id dolor mollis, bibendum eros non, consectetur quam. Maecenas justo sem, elementum sit amet velit sed, condimentum dignissim ipsum.', 
							'Inclusions':'This is the field program inclusions donec eget aliquet libero. Nulla facilisis lobortis lorem, vitae finibus sem pharetra dignissim. Morbi tempor odio quis augue sodales aliquet. Nunc ullamcorper mi consequat, tempor orci a, sollicitudin tellus. Donec vel rutrum risus, ut bibendum quam.', 
							'Notes': 'This is the field program notes... suspendisse scelerisque consectetur urna a venenatis. Aenean dapibus dignissim magna, vel pretium velit scelerisque laoreet. Donec nulla purus, pellentesque ultricies nulla quis, luctus ultrices mi.', 
							'MinParticipant': '25', 'MaxParticipant': '60', 'MinAge': '21',
							'Price': 0.00, 'ChildPrice': 0.00, 'Departing': '2021-10-31', 'Returning': '2022-01-29', 'Capacity': 39, 'IsLeanIn': true, 'IsStrenuous': true, 'isFastPaced': false, 
							'ButtonNo': '12', 'ButtonCaption': 'Discover the alleys', 'Overbooking': 'N',
							'MainImage': 'https://image.shutterstock.com/image-photo/mountains-under-mist-morning-amazing-260nw-1725825019.jpg',
							'CarouselImages': [
								{'path': 'https://image.shutterstock.com/image-photo/mountains-under-mist-morning-amazing-260nw-1725825019.jpg'}, 
								{'path': 'https://image.shutterstock.com/image-photo/mountains-under-mist-morning-amazing-260nw-1725825019.jpg'}, 
								{'path': 'https://image.shutterstock.com/image-photo/mountains-under-mist-morning-amazing-260nw-1725825019.jpg'} 
							]
						  }
		});
    }
	handleSubmit = (event) => {
		event.preventDefault();
		this.props.isSubmitting();
		this.props.removeFieldProgram(this.state.fieldProgramResult)
			.catch(console.error)
			.then(() => { this.props.isSubmitted(); });
	}
	handleUpload(info) {
		this.setState({ 'selectedFiles': info.fileList });
		console.log("files: " + JSON.stringify(info.fileList));
	}
	render() {
        const hasKeys = !!Object.keys(this.state.fieldProgramResult).length;
        const readonly = true;
		const { getFieldDecorator } = this.props.form;
		const {
			Code, CruiseNumber, DepartmentCode, Type, Port, Title, Summary, Description, Itinerary, Inclusions, Notes, 
			MinParticipant, MaxParticipant, MinAge,
			Price, ChildPrice, Departing, Returning, Capacity, IsLeanIn, IsStrenuous, IsFastPaced,
			ButtonNo, ButtonCaption, Overbooking,
			MainImage, CarouselImages
		} = this.state.fieldProgramResult;
        
		return (
			<Form onSubmit={this.handleSubmit}>
                <legend>Retreive Specific Field Program</legend>
                <Form.Item label="Enter Code" {...formItemLayout}>
					{getFieldDecorator('EnterCode', {
						rules: [{ required: true, message: 'Please enter a field program code.' }]
					})(
						<Input onChange={event => this.populateSearchTerm(event.target.value)}/>
					)}
				</Form.Item>
                <Form.Item {...formItemLayout} style={buttonStyle}>
                <Button
                        type="primary"
                        htmlType="button"
                        icon="search"
                        loading={this.props.getStatus().submitting}
                        onClick={this.fetchFieldProgram}>
                        {this.props.buttonText || 'Search'}
                    </Button>
				</Form.Item>
                <div className={hasKeys ? '': 'hidden'}>
				<legend>Remove Field Program</legend>
				<Form.Item label="Code" {...formItemLayout}>
					{getFieldDecorator('Code', {
						initialValue: Code
					})(
						<Input readOnly={readonly} />
					)}
				</Form.Item>
				<Form.Item label="Cruise Number" {...formItemLayout}>
					{getFieldDecorator('CruiseNumber', {
						initialValue: CruiseNumber
					})(
						<Input readOnly={readonly} />
					)}
				</Form.Item>
				<Form.Item label="Department Code" {...formItemLayout}>
					{getFieldDecorator('DepartmentCode', {
						initialValue: DepartmentCode
					})(
						<Input readOnly={readonly} />
					)}
				</Form.Item>
				<Form.Item label="Type" {...formItemLayout}>
					{getFieldDecorator('Type', {
						initialValue: Type
					})(
						<Input readOnly={readonly} />
					)}
				</Form.Item>
				<Form.Item label="Port" {...formItemLayout}>
					{getFieldDecorator('Port', {
						initialValue: Port
					})(
						<Input readOnly={readonly} />
					)}
				</Form.Item>
				<Form.Item label="Title" {...formItemLayout}>
					{getFieldDecorator('Title', {
						initialValue: Title
					})(
						<Input readOnly={readonly} />
					)}
				</Form.Item>
				<Form.Item label="Summary" {...formItemLayout}>
					{getFieldDecorator('Summary', {
						initialValue: Summary
					})(
						<TextArea readOnly={readonly} autosize={{ minRows: 1, maxRows: 6 }} />
					)}
				</Form.Item>
				<Form.Item label="Description" {...formItemLayout}>
					{getFieldDecorator('Description', {
						initialValue: Description
					})(
						<TextArea readOnly={readonly} autosize={{ minRows: 1, maxRows: 10 }}/>
					)}
				</Form.Item>
				<Form.Item label="Itinerary" {...formItemLayout}>
					{getFieldDecorator('Itinerary', {
						initialValue: Itinerary
					})(
						<TextArea readOnly={readonly} autosize={{ minRows: 1, maxRows: 10 }}/>
					)}
				</Form.Item>
				<Form.Item label="Inclusions" {...formItemLayout}>
					{getFieldDecorator('Inclusions', {
						initialValue: Inclusions
					})(
						<TextArea readOnly={readonly} autosize={{ minRows: 1, maxRows: 10 }} />
					)}
				</Form.Item>
				<Form.Item label="Notes" {...formItemLayout}>
					{getFieldDecorator('Notes', {
						initialValue: Notes
					})(
						<TextArea readOnly={readonly} autosize={{ minRows: 1, maxRows: 6 }} />
					)}
				</Form.Item>
				<Form.Item label="Minimum Participants" {...formItemLayout}>
					{getFieldDecorator('MinParticipant', {
						initialValue: MinParticipant
					})(
						<InputNumber min={0} readOnly={readonly} />
					)}
				</Form.Item>
				<Form.Item label="Maximum Participants" {...formItemLayout}>
					{getFieldDecorator('MaxParticipant', {
						initialValue: MaxParticipant
					})(
						<InputNumber min={0} readOnly={readonly} />
					)}
				</Form.Item>
				<Form.Item label="Minimum Age" {...formItemLayout}>
					{getFieldDecorator('MinAge', {
						initialValue: MinAge
					})(
						<InputNumber min={0} readOnly={readonly} />
					)}
				</Form.Item>
				<Form.Item label="Price" {...formItemLayout}>
					{getFieldDecorator('Price', {
						initialValue: Price
					})(
						<InputNumber readOnly={readonly} formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')} parser={value => value.replace(/\s?|(,*)/g, '')} precision={2}/>
					)}
				</Form.Item>
				<Form.Item label="Child Price" {...formItemLayout}>
					{getFieldDecorator('ChildPrice', {
						initialValue: ChildPrice
					})(
						<InputNumber readOnly={readonly} formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')} parser={value => value.replace(/\s?|(,*)/g, '')} precision={2}/>
					)}
				</Form.Item>
				<Form.Item label="Departing" {...formItemLayout}>
					{getFieldDecorator('Departing', {
						initialValue: Departing && moment.utc(Departing)
					})(
						<DatePicker readOnly={readonly} disabled />
					)}
				</Form.Item>
				<Form.Item label="Returning" {...formItemLayout}>
					{getFieldDecorator('Returning', {
						initialValue: Returning && moment.utc(Returning)
					})(
						<DatePicker readOnly={readonly} disabled />
					)}
				</Form.Item>
				<Form.Item label="Capacity" {...formItemLayout}>
					{getFieldDecorator('Capacity', {
						initialValue: Capacity
					})(
						<InputNumber readOnly={readonly} />
					)}
				</Form.Item>
				<Form.Item label="IsLeanIn?" {...formItemLayout}>
					{getFieldDecorator('IsLeanIn', {
						initialValue: IsLeanIn
					})(
						<Checkbox readOnly={readonly} checked={IsLeanIn} />
					)}
				</Form.Item>
				<Form.Item label="IsStrenuous?" {...formItemLayout}>
					{getFieldDecorator('IsStrenuous', {
						initialValue: IsStrenuous
					})(
						<Checkbox readOnly={readonly} checked={IsStrenuous} />
					)}
				</Form.Item>
				<Form.Item label="IsFastPaced?" {...formItemLayout}>
					{getFieldDecorator('IsFastPaced', {
						initialValue: IsFastPaced
					})(
						<Checkbox readOnly={readonly} checked={IsFastPaced} />
					)}
				</Form.Item>
				<Form.Item label="ButtonNumber" {...formItemLayout}>
					{getFieldDecorator('ButtonNumber', {
						initialValue: ButtonNo
					})(
						<InputNumber readOnly={readonly} min={0} />
					)}
				</Form.Item>
				<Form.Item label="ButtonCaption" {...formItemLayout}>
					{getFieldDecorator('ButtonCaption', {
						initialValue: ButtonCaption
					})(
						<Input readOnly={readonly} />
					)}
				</Form.Item>
				<Form.Item label="Overbooking" {...formItemLayout}>
					{getFieldDecorator('Overbooking', {
						initialValue: Overbooking
					})(
						<Input readOnly={readonly} />
					)}
				</Form.Item>
                <Form.Item label="Main Image" {...formItemLayout}>
					{getFieldDecorator('MainImage', {
						initialValue: MainImage
					})(
						<img src={MainImage} />
					)}
				</Form.Item>
                <Form.Item label="Carousel Images" {...formItemLayout}>
					{getFieldDecorator('CarouselImages', {
						initialValue: CarouselImages
					})(
						<Carousel autoplay>
                            {CarouselImages != null ? Object.entries(CarouselImages).map(([key, value]) => {
                                return (
                                    <div key={key}>
                                        <h3 style={contentStyle}>
                                            <img src={value.path} />
                                        </h3>
                                    </div>
                                )
                            }):null}
                        </Carousel>
					)}
				</Form.Item>
                <Form.Item {...formItemLayout} style={buttonStyle}>
                    <Button
                        type="danger"
                        htmlType="submit"
                        icon="delete"
                        loading={this.props.getStatus().submitting}>
                        {this.props.buttonText || 'Delete'}
                    </Button>
                </Form.Item>
                </div>
			</Form>
            
		);
	}
}

export default withSpin(Form.create()(DeleteProgram));


// WEBPACK FOOTER //
// ./portal-components/Portal/FieldAdmin/DeleteProgram/index.jsx